import { inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable, Subject, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private isLocked = false;
  private unlockedTokenSubject = new Subject<string>();
  private cookieService = inject(CookieService);

  public lock(): void {
    this.isLocked = true;
  }

  public unlock(): void {
    this.isLocked = false;
    if (this.unlockedTokenSubject.observed) {
      this.unlockedTokenSubject.next(this.getImmediatelyToken());
    }
  }

  public getToken(): Observable<string> {
    if (!this.isLocked) {
      return of(this.getImmediatelyToken());
    }

    return this.unlockedTokenSubject;
  }

  protected getImmediatelyToken(): string {
    return this.cookieService.get('auth-token') ?? '';
  }

  public setToken(token: string, override = false): void {
    this.cookieService.set('auth-token', token);

    if (override) {
      this.unlock();
    }
  }

  public deleteToken(): void {
    this.cookieService.delete('auth-token');
  }
}
